import { Button, Flex, Popconfirm, Progress, Space, Typography, theme } from 'antd';
import { FC } from 'react';
import { ExclamationCircle, EyeSlash, Trash } from 'react-bootstrap-icons';

import { CircleSpinnerIcon, CopyableText } from '@/common/components';

interface Props {
  refreshInterval: number;
  remainingTime: number;
  generatedCode: string;
  isTokenReceived: boolean;
  isTokenFetching: boolean;
  isTokenVisible: boolean;
  isRemoveOTPLoading: boolean;
  handleRemoveOTP: () => void;
  handleSetTokenVissible: () => void;
  handleSetTokenUnvissible: () => void;
}

export const SearchConsoleAccountOTPAuthenticatorView: FC<Props> = ({
  refreshInterval,
  remainingTime,
  generatedCode,
  isTokenReceived,
  isTokenFetching,
  isTokenVisible,
  isRemoveOTPLoading,
  handleRemoveOTP,
  handleSetTokenUnvissible,
  handleSetTokenVissible
}) => {
  const { token: { colorError, colorPrimary, colorBgLayout } } = theme.useToken();

  return (
    <div style={{ width: '100%' }}>
      {
        isTokenReceived && isTokenVisible
          ? <Flex align="center" justify="space-between">
            <Typography.Title
              style={{ margin: 0, width: 190, display: 'flex', justifyContent: isTokenFetching ? 'center' : 'flex-start' }}
              level={ 5 }
            >
              {
                isTokenFetching
                  ? <CircleSpinnerIcon/>
                  : <CopyableText textToCopy={ generatedCode } iconSize={ 14 }>
                    OTP токен: { generatedCode }
                  </CopyableText>
              }
            </Typography.Title>
            <Progress
              strokeColor={ isTokenFetching ? colorBgLayout : colorPrimary }
              status="normal"
              style={{ transform: 'scale(.7)' }}
              type="circle" size="small"
              percent={ isTokenFetching ? 100 : remainingTime * 100 / refreshInterval }
              format={
                (p) => p! > 0 && !isTokenFetching
                  ? <span style={{ fontSize: 20 }}>{ remainingTime }</span>
                  : <CircleSpinnerIcon/>
              }
            />
            <Space size="small">
              <Button onClick={ handleSetTokenUnvissible } icon={ <EyeSlash size={ 16 }/> }/>
            </Space>
          </Flex>
          : <Flex align="center" gap={ 8 } style={{ width: '100%' }}>
            <Button
              onClick={ handleSetTokenVissible }
              block
              loading={ isTokenFetching || isRemoveOTPLoading }
              disabled={ isTokenFetching || isRemoveOTPLoading }
            >
              Отримати OTP токен
            </Button>
            <Popconfirm
              destroyTooltipOnHide
              title="Видалити токен OTP"
              icon={ <ExclamationCircle color={ colorError }/> }
              onConfirm={ handleRemoveOTP }
              okText="Так, видалити"
              okButtonProps={{ danger: true }}
              cancelText="Ні"
              placement="left"
              disabled={ isRemoveOTPLoading }
            >
              <Button
                type="text"
                danger
                size="middle"
                loading={ isRemoveOTPLoading }
                disabled={ isRemoveOTPLoading }
                icon={ <Trash/> }
              />
            </Popconfirm>
          </Flex>
      }
    </div>
  );
};
